// This component has been consolidated - use PageLayoutWithHeaderNav instead
import PageLayoutWithHeaderNav from "./PageLayoutWithHeaderNav";

const PageLayout = (props) => {
  console.warn(
    "PageLayout is deprecated - use PageLayoutWithHeaderNav directly"
  );
  return <PageLayoutWithHeaderNav {...props} />;
};

export default PageLayout;
